import { baseApi } from './baseApi';
import { setCredentials } from '../slices/authSlice';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query({
      query: () => '/auth/me',
      providesTags: ['User'],
      async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.user) {
            const token = getState().auth.token;
            dispatch(setCredentials({ user: data.user, token }));
          }
        } catch {
          // ignore
        }
      },
    }),
    changePassword: builder.mutation({
      query: (body) => ({
        url: '/auth/change-password',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetMeQuery, useChangePasswordMutation } = authApi;
